import "./view.scss";

const getModalRestUrl = () =>
  (typeof window !== "undefined" && window.falconConfig?.modalRestUrl) ||
  `${window.location.origin}/wp-json/falcon-blocks/v1/`;

// Load modal content via REST and open Fancybox (avoids duplicate forms/reCAPTCHA on page load).
async function ensureModalContent(modalEl) {
  const postId = modalEl?.getAttribute("data-modal-post-id");
  const placeholder = modalEl?.querySelector("[data-modal-placeholder]");
  if (!postId || !placeholder) return;
  const hasContent = placeholder.getAttribute("data-loaded") === "1";
  if (hasContent) return;

  const loadingEl = placeholder.querySelector(".modal-loading");
  if (loadingEl) loadingEl.textContent = "Loading…";

  try {
    const base = getModalRestUrl().replace(/\/?$/, "");
    const postType = modalEl?.getAttribute("data-modal-post-type");
    const currentUrl = (window.location.origin + window.location.pathname + window.location.search).split("#")[0];
    const params = new URLSearchParams();
    if (postType) params.set("post_type", postType);
    params.set("current_url", currentUrl);
    const url = `${base}/modal-content/${postId}?${params.toString()}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error("Failed to load modal content");
    const { content } = await res.json();
    if (loadingEl) loadingEl.remove();
    placeholder.innerHTML = content;
    placeholder.setAttribute("data-loaded", "1");
    // Fix form actions that point at the modal-content API (content was rendered during REST request).
    const baseUrl = currentUrl;
    placeholder.querySelectorAll("form[action*='modal-content'], form[action*='wp-json'], form[action*='falcon_career_modal'], form[action*='falcon_modal_ajax']").forEach((form) => {
      const anchor = (form.getAttribute("action") || "").split("#")[1] || "";
      form.setAttribute("action", baseUrl + (anchor ? "#" + anchor : ""));
    });
    // Fix file upload URLs in GF multifile fields (data-settings.url was set during REST request).
    placeholder.querySelectorAll("[data-settings]").forEach((el) => {
      try {
        const raw = el.getAttribute("data-settings");
        if (!raw) return;
        const settings = JSON.parse(raw);
        const u = settings?.url;
        if (u && (u.includes("modal-content") || u.includes("wp-json") || u.includes("falcon_career_modal") || u.includes("falcon_modal_ajax"))) {
          // Preserve any query string (e.g. gf_page) so GF upload handler works.
          let query = "";
          try {
            const idx = u.indexOf("?");
            if (idx !== -1) query = u.substring(idx + 1);
          } catch (_q) {}
          settings.url = query ? baseUrl + (baseUrl.includes("?") ? "&" : "?") + query : baseUrl;
          el.setAttribute("data-settings", JSON.stringify(settings));
        }
      } catch (_) {}
    });
    // Reset GF submission flag so "Another submission is already in progress" does not block.
    const formEl = placeholder.querySelector("form[id^='gform_']");
    if (formEl?.id) {
      const id = formEl.id.replace("gform_", "");
      if (id) window[`gf_submitting_${id}`] = false;
    }

    // Let Gravity Forms (and reCAPTCHA) initialize on the new content.
    if (typeof jQuery !== "undefined" && placeholder.querySelector(".gform_wrapper")) {
      const gfFormEl = placeholder.querySelector("form[id^='gform_']");
      const gfFormId = gfFormEl?.id ? parseInt(gfFormEl.id.replace("gform_", ""), 10) : null;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (gfFormId) {
            jQuery(document).trigger("gform_post_render", [gfFormId, 1]);
            // Intercept form submission so it works inside the modal (fetch-based instead of iframe).
            if (typeof window.setupGfModalConfirmationFallback === "function") {
              window.setupGfModalConfirmationFallback(placeholder, String(gfFormId));
            }
          } else {
            jQuery(document).trigger("gform_post_render");
          }
        });
      });
    }
  } catch (err) {
    if (loadingEl) loadingEl.textContent = "Unable to load content.";
    console.warn("Button modal content load failed:", err);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const buttonModalElements = document.querySelectorAll("[data-fancybox='button-modal']");

  buttonModalElements.forEach((el) => {
    el.addEventListener("click", async (e) => {
      e.preventDefault();

      const src = el.getAttribute("data-src");
      const modalElement = document.querySelector(src);

      if (!modalElement || !window.showFancyboxModal) return;

      await ensureModalContent(modalElement);
      window.showFancyboxModal(src);
    });
  });
});
